// ChatBubble.jsx
import { User, Bot, Headset } from "lucide-react";

export default function ChatBubble({ msg }) {
    const { user, agent, bot, timestamp } = msg;
    const isUser = !!user;
    const isAgent = !!agent;
    const sender = isUser ? "Usuario" : isAgent ? "Agente" : "Bot";
    const icon = isUser ? <User size={14} /> : isAgent ? <Headset size={14} /> : <Bot size={14} />;
    const content = user || agent || bot;

    return (
        <div className={`chat ${isUser ? "chat-end" : "chat-start"}`}>
            {/* <div className="chat-image avatar placeholder">
                <div className={`bg-base-300 text-base-content rounded-full w-8`}>
                    {icon}
                </div>
            </div> */}

            <div className="chat-header">
                {sender}
                <time className="text-xs opacity-80 ml-2">
                    {new Date(timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                </time>
            </div>

            <div
                className={`chat-bubble ${isUser
                    ? "bg-primary text-primary-content"
                    : isAgent
                        ? "bg-success text-success-content"
                        : "bg-secondary text-secondary-content"
                    }`}
            >
                {content}
            </div>
        </div>
    );
}
